export default __webpack_public_path__ + "static/media/20210227_101131.17b26da3.jpg";